// extracted by mini-css-extract-plugin
export default {"cardWrapper":"I3rSxNbgTAIa0dEZ2Rku","card":"wyZBidbo8t_oPN9nygWk","cardNotification":"ubma29vWYdrhsPu9wh18"};